import railsConfig from '../RailsConfig';
import { isMweb } from '../Utils/device';

export const pushPdtData = async (pdtData) => {
  const PDT_ARRAY = [pdtData];
  const apiDataArr = JSON.stringify(PDT_ARRAY);
  const xmlhttp = new XMLHttpRequest();
  xmlhttp.open('POST', railsConfig.pdtUrl, true);
  xmlhttp.setRequestHeader('Content-type', 'application/json');
  xmlhttp.setRequestHeader('Content-Encoding', 'gzip');
  xmlhttp.setRequestHeader('Request-Data-Encoding', 'json');
  if (isMweb()) {
    const pako = require('pako');
    const output = pako.gzip(apiDataArr);
    xmlhttp.send(output);
  } else {
    xmlhttp.send(apiDataArr);
  }
};
